/**
 * @description LYN-410 SO employee roster and pending-match client.
 *
 * Key features:
 * - List, pending, options, resolve
 * - Session company is X-Company-Id. All omits the header.
 *
 * @dependencies apiClient
 *
 * @notes No vendor names. No Assets & Crew. Query companyId is never sent.
 */

import apiClient from './apiClient';

/**
 * @returns {Promise<object>}
 */
export function listSoEmployees(params = {}) {
  return apiClient.get('/so/employees', { params }).then((response) => response.data);
}

/**
 * @returns {Promise<object>}
 */
export function listPendingMatches() {
  return apiClient.get('/so/employees/pending-matches').then((response) => response.data);
}

/**
 * @returns {Promise<object>}
 */
export function listEmployeeOptions() {
  return apiClient.get('/so/employees/options').then((response) => response.data);
}

/**
 * @param {string} pendingId
 * @param {{ employeeId?: string, create?: boolean }} body
 * @returns {Promise<object>}
 */
export function resolvePendingMatch(pendingId, body) {
  return apiClient
    .post(`/so/employees/pending-matches/${pendingId}/resolve`, body)
    .then((response) => response.data);
}

const soEmployeesService = {
  listSoEmployees,
  listPendingMatches,
  listEmployeeOptions,
  resolvePendingMatch
};

export default soEmployeesService;
